import { INote } from '~/types/campaigns';

// CampaignRequestNote objects have campaign_request field; Message objects have campaign field.
// The two tables number their rows independently, so an id from one will happily
// match an unrelated row in the other — always route by source, never by id alone.
export const isCampaignRequestNote = (note: INote) => {
    return (
        'campaign_request' in note &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !('campaign' in note && (note as any).campaign)
    );
};

// The campaign request a CampaignRequestNote belongs to, or null for a Message.
// Pages that list both kinds side by side route each update/delete by this.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const campaignRequestIdOf = (note: any): number | null =>
    isCampaignRequestNote(note) ? Number(note.campaign_request) || null : null;
